import { host, domain } from '../../utilities/requests';

export const request_sso_login = async (register=false) => {
    var forRegister = register === 'true' || register == true;
    console.log(forRegister, "registered");
    const init = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        register: forRegister,
      }),
    };

    try {
      const response = await fetch(host + '/api/sso/request_login/', init);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP Error ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      window.location.href = `${data.auth_url}?clientId=${data.client_id}&state=${data.state}&returnUrl=https://${domain}/sso_callback`;

    } catch (error) {
      console.error('خطا در درخواست SSO:', error);
      throw error;
    }
};